import colors from './styles/colors'
import { categoryMenuTypeEnum } from 'enums'
import { isProduction } from 'variables/environment'
import { BrandConfigType } from 'types'
import { getBrandDefaultFeatures } from 'brands'
import { BrandTypeEnum } from 'enums'

const brand: BrandConfigType = {
  liffID: {
    home: isProduction ? '1578956419-zxY7Rmbd' : '1657129684-rn0x96qM',
    customer_feedback: isProduction ? '1578956419-mMq5nJOG' : '1649469421-pln6yq4D',
    upload_bankslip: isProduction ? '1578956419-5Nbg3Yjq' : '1649469421-vxKGwLQg',
    lineID: isProduction ? '@gongang' : '@844gqoba',
  },
  id: isProduction ? 4 : 92,
  categoryEnNameSelected: 'Party Service',
  slug: 'party-service',
  title: 'GON Delivery',
  label: `บริการยืมเตา`,
  labelListScheduledContent: 'Bar B Q Plaza',
  type: BrandTypeEnum.MULTI_BRAND,
  slogan: `ชุดยืมเตา
สั่งได้หลายแบรนด์ ในออร์เดอร์เดียว`,
  favIcon: `${process.env.PUBLIC_URL}/assets/fav-indydish.png`,
  brandSelectImg: `${process.env.PUBLIC_URL}/assets/brand/icon-brand-gon-services-original.jpeg`,
  theme: {
    ui: 'gon',
    colors,
  },
  googleAnalytics: {
    key: isProduction ? 'UA-111558437-5' : '',
  },
  ga4: {
    hatoStoreKey: isProduction ? 'G-D2VPLX4RNE' : '',
    hatoHeartKey: isProduction ? 'G-BZX0MS6VJX' : '',
    dineInKey: isProduction ? 'G-6RV10ZT75X' : '',
    brandDineInKey: isProduction ? 'G-39CQ3LV77F' : 'G-1REZB59SZH',
    crmKey: isProduction ? 'G-0H0EK45LYZ' : '',
    buffetKey: isProduction ? 'G-GE88CDYWSG' : '',
  },
  omisePublicKey: isProduction ? 'pkey_5jm0nnzg0cax9wu4t5u' : 'pkey_test_5jdsi5cq16tbwjuto9z',
  categoryMenuType: categoryMenuTypeEnum.SearchDropdown,
  i18n: {
    th: {
      productExcludedPromotionShort: '*ไม่สามารถร่วมกับส่วนลดสมาชิกและอื่นๆได้',
      productExcludedPromotion: 'สินค้าชิ้นนี้ไม่สามารถร่วมกับส่วนลดสมาชิกและอื่นๆได้',
    },
    en: {
      productExcludedPromotionShort: '*Can’t be applied with member discounts and others.',
      productExcludedPromotion: 'This item can’t be applied with member discounts and others.',
    },
  },
  features: getBrandDefaultFeatures({ hatostore: { enableETax: true } }),
}

export default brand
